import { isWordLevel } from '@skjv/common';
import { getBookAbbrev, getLocationTitle } from './pdf-helpers.js';
import { renderWritingSection } from './pdf-student-writing.js';
export async function configureStudentPage(doc, study, assignment, vts) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginSize = pageWidth * 0.03;
    const padding = 3;
    const bookAbbrev = getBookAbbrev(study.startingLocation);
    const locationTitle = getLocationTitle(study.startingLocation, study.endingLocation);
    const pageHeader = `${bookAbbrev} ${locationTitle} -- ${study.name}`;
    let currentFontSize = 10;
    let currentY = currentFontSize;
    doc.setFontSize(currentFontSize);
    doc.setTextColor('#333');
    doc.text(pageHeader, pageWidth / 2, currentY, { align: 'center' });
    const readingLevel = assignment.student.readingLevel;
    const isWordReading = readingLevel !== undefined && isWordLevel(readingLevel) && !!assignment.readingFragment;
    let assignmentHeader;
    if (assignment.readingFragment) {
        assignmentHeader = assignment.readingFragment;
    }
    else if (assignment.startingLocation) {
        const assignmentBookAbbrev = getBookAbbrev(study.startingLocation);
        const assignmentLocationTitle = getLocationTitle(assignment.startingLocation, assignment.endingLocation);
        assignmentHeader = `${assignmentBookAbbrev} ${assignmentLocationTitle}`;
    }
    else {
        assignmentHeader = `${bookAbbrev} ${locationTitle}`;
    }
    let lines = doc.splitTextToSize(assignmentHeader, pageWidth - 2 * marginSize - 2 * padding);
    let rectHeight = currentFontSize * lines.length + currentFontSize;
    currentFontSize = 16;
    currentY = currentY + 11;
    doc.rect(marginSize, currentY - 8, pageWidth - 2 * marginSize, rectHeight);
    currentFontSize = 14;
    currentY = currentY - 2.5;
    doc.setFontSize(currentFontSize);
    doc.setFont('helvetica', 'bold');
    doc.text(assignment.student.name, marginSize + padding, currentY, { align: 'left' });
    currentY = currentY + 9;
    // Word-mode readers get their picked word(s) large and bold — the
    // assignment IS the word, so it leads the page
    doc.setFontSize(isWordReading ? 20 : currentFontSize);
    doc.setFont('helvetica', isWordReading ? 'bold' : 'normal');
    const txt = doc.splitTextToSize(assignmentHeader, pageWidth - 2 * marginSize - 2 * padding);
    doc.text(txt, marginSize + padding, currentY, { align: 'left' });
    doc.setFont('helvetica', 'normal');
    lines = txt.length;
    currentY = currentY + 6 * lines + 2;
    const bottomMargin = 32;
    const mainRectHeight = pageHeight - currentY - bottomMargin;
    doc.rect(marginSize, currentY, pageWidth - 2 * marginSize, mainRectHeight);
    currentY = currentY + 5;
    const rectWidth = pageWidth - 2 * marginSize - 2 * padding;
    const currentX = marginSize + padding;
    const sceneCount = study.scenes.filter((s) => s.descriptions[0]).length || 1;
    // A NONE writer has no writing section — scenes get the space back
    const hasWritingSection = assignment.student.writingLevel !== 'NONE';
    const writingReserve = hasWritingSection ? 30 + 5 + 30 + 10 : 0;
    const sceneSectionHeight = mainRectHeight - writingReserve;
    rectHeight = Math.min(sceneSectionHeight / sceneCount - padding - 1, pageHeight * 0.3);
    for (const scene of study.scenes) {
        const [statement, ...discussionPoints] = scene.descriptions;
        if (!statement)
            continue;
        currentFontSize = 10;
        doc.setFontSize(currentFontSize);
        doc.setFont('helvetica', 'bold');
        const summaryText = doc.splitTextToSize(statement, rectWidth - padding);
        doc.text(summaryText, currentX + padding / 2, currentY + 4, { align: 'left' });
        if (discussionPoints.length > 0) {
            const pointsText = discussionPoints
                .filter((p) => p.trim())
                .map((p, i) => `${i + 1}) ${p}`)
                .join('  ');
            if (pointsText) {
                const statementHeight = summaryText.length * 4;
                currentFontSize = 8;
                doc.setFontSize(currentFontSize);
                doc.setFont('helvetica', 'normal');
                const pointLines = doc.splitTextToSize(pointsText, rectWidth - padding * 2);
                doc.text(pointLines, currentX + padding, currentY + 4 + statementHeight, { align: 'left' });
            }
        }
        doc.rect(currentX, currentY, rectWidth, rectHeight);
        currentY = currentY + rectHeight + padding + 1;
    }
    if (hasWritingSection) {
        await renderWritingSection(doc, study, assignment, vts, currentY, {
            pageWidth,
            pageHeight,
            marginSize,
            padding,
        });
    }
}
//# sourceMappingURL=pdf-student-page.js.map